import InfoPopup from "components/InfoPopup"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Button,
  Alert,
} from "reactstrap"
import { useNavigate } from "react-router-dom"
import { getUserDetailsRequest } from "../../redux/actions/auth"
import { getPvsDetails } from "../../redux/actions/pvs"

const PVSInfo = ({ pvsDetails }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)
  const [openAccordion, setOpenAccordion] = useState("0")
  const [hasActiveApplication, setHasActiveApplication] = useState(false)
  const [activeApplication, setActiveApplication] = useState(null)

  const user = useSelector(state => state.auth.user)
  const pvsCards = useSelector(state => state.auth.pvs_cards)
  const pvsFormData = useSelector(state => state.pvs.pvsFormData)

  useEffect(() => {
    dispatch(getUserDetailsRequest())
  }, [])

  useEffect(() => {
    console.log("activeApplication...", activeApplication)
  }, [activeApplication])
  

  useEffect(() => {
    if (user && user.pvs_entries && user.pvs_entries.length > 0) {
      let pendingPVS = user.pvs_entries.find(
        pvs => pvs.status === "pending" || pvs.status === "paid"
      )
      if (pendingPVS) {
        setHasActiveApplication(true)
        setActiveApplication(pendingPVS)
      }
    }
    if (user && user.pvs_entries && user.pvs_entries.length > 0) {
      let pendingPVS = user.pvs_entries.find(
        pvs => pvs.status === "clarification"
      )
      if (pendingPVS) {
        setHasActiveApplication(true)
        setActiveApplication(pendingPVS)
      }
    }
  }, [user])

  useEffect(() => {
    if (activeApplication && activeApplication.status === "clarification") {
      dispatch(
        getPvsDetails({
          enc_pvs_entry_id: activeApplication.enc_pvs_entry_id,
        })
      )
    }
  }, [activeApplication])

  const toggleAccordion = id => {
    setOpenAccordion(openAccordion === id ? "" : id)
  }

  const openPreview = (path, label) => {
    setPreviewFile({
      url: path,
      name: label,
      type: "image/jpeg",
    })
    setPreviewOpen(true)
  }

  const closePreview = () => {
    setPreviewOpen(false)
    setPreviewFile(null)
  }

  const handleDownload = (url, filename) => {
    fetch(url, { mode: "cors" }) // Fetch the file
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = filename // Set desired filename
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
      .catch(err => console.error("Download failed:", err))
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-end mt-4 mb-3">
          <div className="flex-grow-1">
            <h4 className="h4 mb-3 nom-title">PVS Cards</h4>
          </div>

          <Button
            color={
              activeApplication && activeApplication.status === "clarification"
                ? "warning"
                : "primary"
            }
            className={`btn-medium ${
              activeApplication && activeApplication.status === "paid"
                ? "disabled btn-disabled"
                : ""
            }`}
            onClick={() => {
              if (
                activeApplication &&
                activeApplication.status === "clarification"
              ) {
                navigate("/pvs-registration", {
                  state: { allowEdit: true },
                })
              } else {
                navigate("/pvs-registration")
              }
            }}
          >
            {activeApplication &&
            (activeApplication.status === "pending" ||
              activeApplication.status === "clarification") ? (
              <i className="mdi mdi-folder-edit-outline me-2"></i>
            ) : null}
            {activeApplication && activeApplication.status === "pending"
              ? "Continue Application"
              : activeApplication && activeApplication.status === "paid"
              ? "Application In Review"
              : activeApplication &&
                activeApplication.status === "clarification"
              ? "Edit Application"
              : "Apply for New PVS Card"}
          </Button>
        </div>
        {pvsFormData && pvsFormData.status === "clarification" && (
          <div className="mt-4 pt-4 mb-3 pb-3">
            <Alert color="warning" className="mb-0" role="alert">
              <h2 className="alert-heading font-18">Attention!!</h2>
              <p className="mb-2">Please update the following information:</p>
              <ul>
                {pvsFormData.remarks &&
                  pvsFormData.remarks.split(",").map((remark, index) => (
                    <li key={index}>{remark}</li>
                  ))}
              </ul>
            </Alert>
          </div>
        )}
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">Active PVS Cards</h4>
            {pvsCards?.length > 0 ? (
              <Accordion open={openAccordion} toggle={toggleAccordion}>
                {pvsCards.map((pvs, index) => (
                  <AccordionItem key={index}>
                    <AccordionHeader targetId={String(index)}>
                      <i className="mdi mdi-store me-2 text-primary"></i>
                      <strong>
                        {`Card No: ${pvs.token_code} for ${pvs.brand_name}` ||
                          "—"}
                      </strong>
                    </AccordionHeader>

                    <AccordionBody accordionId={String(index)}>
                      <Row className="gy-4 pula-info-card">
                        {/* LEFT COLUMN */}
                        <Col md={6}>
                          {[
                            { label: "Seller Name", value: pvs.seller_name },
                            { label: "Mobile", value: pvs.seller_contact_no },
                            { label: "Keywords", value: pvs.keywords_label },
                            {
                              label: "Permanent Address",
                              value: pvs.permanent_address,
                            },
                            {
                              label: "Facebook Link",
                              value: pvs.social_fb_link,
                              isLink: true,
                            },
                          ].map((item, i) => (
                            <div className="pula-info-row" key={i}>
                              <span className="label">{item.label}</span>
                              <span className="colon">:</span>
                              {item.isLink && item.value ? (
                                <a
                                  href={item.value}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="value"
                                >
                                  {item.value}
                                </a>
                              ) : (
                                <span className="value">
                                  {item.value || "-"}
                                </span>
                              )}
                            </div>
                          ))}
                        </Col>

                        {/* RIGHT COLUMN */}
                        <Col md={6}>
                          {[
                            { label: "Email", value: pvs.seller_email_id },
                            {
                              label: "Interest",
                              value: pvs.categories_label,
                            },
                            { label: "Address", value: pvs.address },
                          ].map((item, i) => (
                            <div className="pula-info-row" key={i}>
                              <span className="label">{item.label}</span>
                              <span className="colon">:</span>
                              <span className="value">{item.value || "-"}</span>
                            </div>
                          ))}
                        </Col>
                      </Row>

                      {/* ================= PVS CARD DETAILS ================= */}
                      <Row className="pula-card-info align-items-center">
                        <div className="pula-card-header">
                          <div className="pula-card-title">
                            <i
                              className="ion ion-ios-albums text-success me-2"
                              style={{ fontSize: "20px" }}
                            ></i>
                            PVS Card Details
                          </div>
                        </div>
                        <Col md={12} className="mt-4 mb-2">
                          {[
                            {
                              label: "Brand Name",
                              value: pvs.brand_name,
                            },
                            {
                              label: "Card Number",
                              value: pvs.token_code,
                            },
                            {
                              label: "Pay Id",
                              value: pvs.pay_id,
                            },
                            {
                              label: "Paid Amount",
                              value: <span> ₹ {pvs.amount || "-"}</span>,
                            },
                            {
                              label: "Download Card",
                              value: (
                                <span>
                                  <a
                                    href="#"
                                    onClick={e => {
                                      e.preventDefault()
                                      handleDownload(
                                        pvs.pvs_card_link,
                                        `${pvs.token_code}.jpg`
                                      )
                                    }}
                                    className="btn-primary"
                                  >
                                    Download
                                  </a>
                                </span>
                              ),
                            },
                          ].map((item, index) => (
                            <div key={index} className="mb-2 d-flex">
                              <strong style={{ width: "150px" }}>
                                {item.label}
                              </strong>
                              <span style={{ width: "30px" }}>:</span>
                              <span>{item.value || "-"}</span>
                            </div>
                          ))}
                        </Col>
                        {/* <Col md={12} className="pvsdet-img-col">
                            <img
                              src={
                                pvs.pvs_card_link ||
                                "/default-card.png"
                              }
                              alt="PVS Card"
                              className="img-thumbnail img-fluid mb-2"
                              style={{ maxHeight: "120px" }}
                            />
                          </Col> */}
                      </Row>

                      {/* ================= PVS DOCUMENTS (LIST / TABLE) ================= */}
                      {/* <Card className="pula-profile-card">
                        <div className="pula-card-header">
                          <div className="pula-card-title">
                            <i className="ion ion-ios-document"></i>
                            <span>PVS Documents</span>
                          </div>
                        </div>

                        <CardBody className="p-0">
                          {pvsCards &&
                          pvsCards[0] &&
                          [
                            pvsCards[0].aadhar_card_img_path,
                            pvsCards[0].aadhar_card_img_back_path,
                            pvsCards[0].permanent_address_img_path,
                            pvsCards[0].pune_address_img_path,
                            pvsCards[0].brand_logo_path,
                            pvsCards[0].seller_photo_path,
                          ].some(Boolean) ? (
                            <table className="pula-doc-table">
                              <thead>
                                <tr>
                                  <th>Document</th>
                                  <th className="text-center">Preview</th>
                                  <th className="text-center">Download</th>
                                </tr>
                              </thead>
                              <tbody>
                                {[
                                  {
                                    label: "Aadhar Card Front",
                                    path: pvsCards[0].aadhar_card_img_path,
                                  },
                                  {
                                    label: "Aadhar Card Back",
                                    path: pvsCards[0].aadhar_card_img_back_path,
                                  },
                                  {
                                    label: "Permanent Address",
                                    path: pvsCards[0]
                                      .permanent_address_img_path,
                                  },
                                  {
                                    label: "Pune Address",
                                    path: pvsCards[0].pune_address_img_path,
                                  },
                                  {
                                    label: "Brand Logo",
                                    path: pvsCards[0].brand_logo_path,
                                  },
                                  {
                                    label: "Seller Photo",
                                    path: pvsCards[0].seller_photo_path,
                                  },
                                ]
                                  .filter(doc => doc.path)
                                  .map((doc, index) => (
                                    <tr key={index}>
                                      <td>{doc.label}</td>

                                      <td className="text-center">
                                        <button
                                          className="pula-icon-btn"
                                          onClick={() =>
                                            openPreview(doc.path, doc.label)
                                          }
                                        >
                                          <i className="ion ion-md-eye"></i>
                                        </button>
                                      </td>

                                      <td className="text-center">
                                        <button
                                          className="pula-icon-btn"
                                          onClick={() =>
                                            handleDownload(
                                              doc.path,
                                              `${doc.label.replace(
                                                /\s+/g,
                                                "_"
                                              )}.jpg`
                                            )
                                          }
                                        >
                                          <i className="ion ion-md-download"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          ) : (
                            <div className="pula-no-data">
                              No Documents Found
                            </div>
                          )}
                        </CardBody>
                      </Card> */}
                    </AccordionBody>
                  </AccordionItem>
                ))}
              </Accordion>
            ) : (
              <div className="pula-no-data text-center">
                No PVS Details Found
              </div>
            )}
          </CardBody>
        </Card>
        <InfoPopup
          isOpen={previewOpen}
          toggle={closePreview}
          title="Document Preview"
          previewFile={previewFile}
          btnClass="btn-primary"
        />
      </div>
    </div>
  )
}

export default PVSInfo
